export const isEmpty = (value: any) => value == null || (Object.keys(value) || value).length === 0
